export const MaskedLines = ({ lines, className = "", lineClassName = "" }) => (
    <span className={className}>
        {lines.map((line, i) => (
            <span key={i} className={`block ${lineClassName}`}>
                {line}
            </span>
        ))}
    </span>
);

export const FadeUp = ({ children, className = "" }) => (
    <div className={className}>{children}</div>
);

export const Eyebrow = ({ children, className = "" }) => (
    <p
        className={`font-mono text-[11px] font-medium uppercase tracking-[0.25em] text-gold-deep ${className}`}
    >
        {children}
    </p>
);
